import { Calendar, Search, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from '@/shared/config/routes';
import { cn } from '@/shared/lib';

/**
 * Bottom bar in the client hub.
 *
 * The search entry points at the public catalogue: the generated markup linked
 * to /client/explore, which is not a route and rendered a 404.
 */
const CLIENT_LINKS = [
  { icon: Search, labelKey: 'clientNav.search', path: ROUTES.explore },
  { icon: Calendar, labelKey: 'clientNav.myBookings', path: ROUTES.client.bookings },
  { icon: User, labelKey: 'clientNav.profile', path: ROUTES.client.profile },
];

export const ClientMobileNav = () => {
  const { t } = useTranslation('app');
  const { pathname } = useLocation();

  return (
    <nav className="pb-safe fixed bottom-0 z-40 flex w-full items-center justify-between border-t border-gray-100 bg-white/95 px-8 py-3 backdrop-blur-md md:hidden">
      {CLIENT_LINKS.map(({ icon: Icon, labelKey, path }) => {
        const active = pathname.startsWith(path);
        return (
          <Link
            key={path}
            to={path}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'flex flex-col items-center gap-1',
              active ? 'text-primary' : 'text-gray-400',
            )}
          >
            <Icon size={24} className={cn(active && 'fill-primary/10 stroke-primary')} />
            <span className="text-[10px] font-bold">{t(labelKey)}</span>
          </Link>
        );
      })}
    </nav>
  );
};
